import { PageContainer } from "components/PageContainer";

export const ComparePage = () => {
  return <PageContainer>Coming Soon</PageContainer>;
};
